import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import HomePage from "./components/HomePage";
import Login from './components/Login';
import Register from './components/Register';
import Dashboard from './components/Dashboard';
import MakeIntegration from './components/MakeIntegration';
import MondayIntegration from './components/MondayIntegration';
import ZapierIntegration from './components/ZapierIntegration';
import N8nIntegration from './components/N8nIntegration';
import DiscordIntegration from './components/DiscordIntegration'; // new
import TelegramIntegration from './components/TelegramIntegration'; // new

function App() {
  const isAuthenticated = !!localStorage.getItem('access_token');

  return (
    <Router>
      <Routes>
        {/* Default route -> Homepage */}
        <Route path="/" element={<HomePage />} />

        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Protected routes */}
        <Route
          path="/dashboard"
          element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" />}
        />
        <Route
          path="/make"
          element={isAuthenticated ? <MakeIntegration /> : <Navigate to="/login" />}
        />
        <Route
          path="/monday"
          element={isAuthenticated ? <MondayIntegration /> : <Navigate to="/login" />}
        />
        <Route
          path="/zapier"
          element={isAuthenticated ? <ZapierIntegration /> : <Navigate to="/login" />}
        />
        <Route
          path="/n8n"
          element={isAuthenticated ? <N8nIntegration /> : <Navigate to="/login" />}
        />
        <Route
          path="/discord"
          element={isAuthenticated ? <DiscordIntegration /> : <Navigate to="/login" />}
        />
        <Route
          path="/telegram"
          element={isAuthenticated ? <TelegramIntegration /> : <Navigate to="/login" />}
        />

        {/* Catch-all: redirect to homepage */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
